import { Controller } from '@hotwired/stimulus'

// Auto-populates a slug field from a title while allowing manual overrides.
export default class extends Controller {
  static targets = ['source', 'output']

  connect() {
    this.userEdited = this.outputTarget.value.trim().length > 0
  }

  update() {
    if (this.userEdited) return
    const generated = this.parameterize(this.sourceTarget.value)
    this.outputTarget.value = generated
  }

  markEdited() {
    this.userEdited = this.outputTarget.value.trim().length > 0
  }

  parameterize(value) {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80)
  }
}
